import { ref, computed } from 'vue'
import { useContext } from '@/plugins/context'
import { useSettingsStore } from '@/stores/settingsStore'
import zeissNewCardIcon from '@/assets/images/zeiss-new-card.svg'

export interface HomeScreenButtonDef {
  id: number
  title: string
  route: string
  icon: string
  iconPrefix?: string
  iconify?: string
  image?: string
  isSuccess?: boolean
  isDanger?: boolean
  permissionAction: string
  permissionResource: string
  settingFlag?: string
  settingFlags?: string[]
  category: string
}

export const ALL_BUTTONS: HomeScreenButtonDef[] = [
  // Sales
  {
    id: 0,
    title: 'views.sales.newSale',
    route: '/sales/new-sale',
    icon: 'new-sale',
    iconPrefix: 'fac',
    isSuccess: true,
    permissionAction: 'create',
    permissionResource: '/sales/orders',
    category: 'sales'
  },
  {
    id: 8,
    title: 'views.sales.orders.returnOrder',
    route: '/sales/orders/return-orders',
    icon: 'return-sale',
    isDanger: true,
    permissionAction: 'create',
    permissionResource: '/sales/returns',
    category: 'sales'
  },
  {
    id: 5,
    title: 'views.sales.orders.orders',
    route: '/sales/orders',
    icon: 'receipt',
    permissionAction: 'read',
    permissionResource: '/sales/orders',
    category: 'sales'
  },
  {
    id: 11,
    title: 'views.sales.transactions.transactions',
    route: '/sales/transactions',
    icon: 'exchange-alt',
    permissionAction: 'read',
    permissionResource: '/accounting/transactions',
    category: 'sales'
  },
  {
    id: 10,
    title: 'views.sales.quotes.quotes',
    route: '/sales/quotes',
    icon: '',
    iconify: 'hugeicons:invoice-01',
    permissionAction: 'read',
    permissionResource: '/sales/quotes',
    category: 'sales'
  },
  // Inventory
  {
    id: 2,
    title: 'views.inventory.items.newSimpleItem',
    route: '/inventory/items/new-simple-item',
    icon: 'plus',
    permissionAction: 'create',
    permissionResource: '/inventory/items',
    category: 'inventory'
  },
  {
    id: 1,
    title: 'views.inventory.items.items',
    route: '/inventory/items',
    icon: 'eye',
    permissionAction: 'read',
    permissionResource: '/inventory/items',
    category: 'inventory'
  },
  {
    id: 12,
    title: 'views.inventory.itemBatches.itemBatches',
    route: '/inventory/item-batches',
    icon: 'boxes',
    permissionAction: 'read',
    permissionResource: '/inventory/items',
    category: 'inventory'
  },
  {
    id: 4,
    title: 'views.inventory.inventoryReceivings.newInventoryReceiving',
    route: '/inventory/inventory-receivings/new-inventory-receiving',
    icon: 'arrow-down',
    permissionAction: 'create',
    permissionResource: '/inventory/inventoryreceivings',
    category: 'inventory'
  },
  {
    id: 13,
    title: 'views.inventory.inventoryAdjustments.newInventoryAdjustment',
    route: '/inventory/inventory-adjustments/new-inventory-adjustment',
    icon: 'cogs',
    permissionAction: 'create',
    permissionResource: '/inventory/inventoryadjustments',
    category: 'inventory'
  },
  {
    id: 14,
    title: 'views.inventory.inventoryTransfers.newInventoryTransfer',
    route: '/inventory/inventory-transfers/new-inventory-transfer',
    icon: 'arrows-alt-h',
    permissionAction: 'create',
    permissionResource: '/inventory/inventorytransfers',
    category: 'inventory'
  },
  {
    id: 15,
    title: 'views.inventory.missingSerials.missingSerials',
    route: '/inventory/missing-serials',
    icon: 'ban',
    permissionAction: 'read',
    permissionResource: '/inventory/items',
    category: 'inventory'
  },
  {
    id: 16,
    title: 'views.inventory.purchaseOrders.newPurchaseOrder',
    route: '/inventory/new-purchase-order',
    icon: 'shopping-cart',
    permissionAction: 'create',
    permissionResource: '/inventory/purchaseorders',
    category: 'inventory'
  },
  // Customers
  {
    id: 6,
    title: 'views.customers.customers',
    route: '/customers',
    icon: 'users',
    permissionAction: 'read',
    permissionResource: '/customer/customers',
    category: 'customers'
  },
  {
    id: 7,
    title: 'views.customers.newCustomer',
    route: '/customers/new-customer',
    icon: 'user-plus',
    permissionAction: 'create',
    permissionResource: '/customer/customers',
    category: 'customers'
  },
  {
    id: 17,
    title: 'views.customers.notes.notes',
    route: '/customers/notes',
    icon: 'book',
    permissionAction: 'read',
    permissionResource: '/customer/customers',
    category: 'customers'
  },
  {
    id: 18,
    title: 'views.customers.birthdays',
    route: '/customers/birthdays',
    icon: 'calendar-day',
    permissionAction: 'read',
    permissionResource: '/customer/customers',
    category: 'customers'
  },
  {
    id: 19,
    title: 'views.appointments.newAppointment',
    route: '/appointments/new-appointment',
    icon: 'calendar-day',
    permissionAction: 'read',
    permissionResource: '/customer/appointments',
    category: 'customers'
  },
  // Companies
  {
    id: 20,
    title: 'views.companies.vendors.vendors',
    route: '/companies/vendors',
    icon: 'store',
    permissionAction: 'read',
    permissionResource: '/vendor/vendors',
    category: 'companies'
  },
  {
    id: 21,
    title: 'views.companies.deliveries.deliveries',
    route: '/companies/deliveries',
    icon: 'truck',
    permissionAction: 'read',
    permissionResource: '/company/delivery',
    category: 'companies'
  },
  // HR
  {
    id: 22,
    title: 'views.hr.employees.employees',
    route: '/hr/employees',
    icon: 'users',
    permissionAction: 'read',
    permissionResource: '/user/users',
    category: 'hr'
  },
  {
    id: 23,
    title: 'views.hr.employees.newEmployee',
    route: '/hr/employees/new-employee',
    icon: 'user-plus',
    permissionAction: 'create',
    permissionResource: '/user/users',
    category: 'hr'
  },
  {
    id: 24,
    title: 'views.hr.tasks.tasks',
    route: '/hr/tasks',
    icon: 'list',
    permissionAction: 'read',
    permissionResource: '/hr/tasks',
    category: 'hr'
  },
  {
    id: 25,
    title: 'views.hr.employeeSchedules.newEmployeeSchedule',
    route: '/hr/employee-schedules/new-employee-schedule',
    icon: 'calendar-day',
    permissionAction: 'create',
    permissionResource: '/user/users',
    category: 'hr'
  },
  // Accounting
  {
    id: 26,
    title: 'views.accounting.accounts.accounts',
    route: '/accounting/accounts',
    icon: 'address-book',
    permissionAction: 'read',
    permissionResource: '/accounting/accounts',
    category: 'accounting'
  },
  {
    id: 27,
    title: 'views.accounting.transactions.transactions',
    route: '/accounting/transactions',
    icon: 'exchange-alt',
    permissionAction: 'read',
    permissionResource: '/accounting/transactions',
    category: 'accounting'
  },
  {
    id: 28,
    title: 'views.accounting.company.company',
    route: '/accounting/company',
    icon: 'warehouse',
    permissionAction: 'read',
    permissionResource: '/accounting/company',
    category: 'accounting'
  },
  {
    id: 29,
    title: 'views.accounting.safesAndBanks.safesAndBanks',
    route: '/accounting/safes-banks',
    icon: 'landmark',
    permissionAction: 'read',
    permissionResource: '/accounting/accounts',
    category: 'accounting'
  },
  // Examinations
  {
    id: 3,
    title: 'views.examinations.newExamination',
    route: '/examinations/new-examination',
    icon: 'icon-examination',
    permissionAction: 'create',
    permissionResource: '/examination/examinations',
    settingFlag: 'examinations_module',
    category: 'examinations'
  },
  {
    id: 32,
    title: 'views.examinations.newZeissCard',
    route: '/examinations/zeiss-cards/new-card',
    icon: 'id-card',
    image: zeissNewCardIcon,
    permissionAction: 'create',
    permissionResource: '/examination/zeiss-cards',
    settingFlags: ['examinations_module', 'enable_zeiss_cards_feature'],
    category: 'examinations'
  },
  // Vets
  {
    id: 30,
    title: 'views.vets.newVetService',
    route: '/vet-services/new',
    icon: 'medkit',
    permissionAction: 'create',
    permissionResource: '/customer/vet-services',
    settingFlag: 'vet_module',
    category: 'vets'
  },
  {
    id: 31,
    title: 'views.pets.newPet',
    route: '/pets/new-pet',
    icon: 'user',
    permissionAction: 'create',
    permissionResource: '/customer/pets',
    settingFlag: 'vet_module',
    category: 'vets'
  }
]

export const DEFAULT_BUTTON_IDS = [0, 8, 5, 10, 1, 2, 6, 7, 24]
export const DEFAULT_BUTTON_IDS_EXAM = [0, 8, 5, 10, 1, 2, 6, 7, 3]

export function buttonFlagsEnabled(
  btn: HomeScreenButtonDef,
  getValue: (key: string) => string | undefined | null
): boolean {
  const flags = [...(btn.settingFlag ? [btn.settingFlag] : []), ...(btn.settingFlags ?? [])]
  return flags.every(flag => getValue(flag) === 'true')
}

function getDefaultIds() {
  const settingsStore = useSettingsStore()
  return settingsStore.getValue('examinations_module') === 'true'
    ? [...DEFAULT_BUTTON_IDS_EXAM]
    : [...DEFAULT_BUTTON_IDS]
}

const BUTTON_MAP = new Map(ALL_BUTTONS.map(b => [b.id, b]))

export function useHomeScreen() {
  const ctx = useContext()
  const storageKey = `homescreen_buttons_${ctx.machineGUID}`
  const examInjectedKey = `homescreen_exam_injected_${ctx.machineGUID}`

  const settingsStore = useSettingsStore()

  function loadInitialIds(): number[] {
    const stored = localStorage.getItem(storageKey)
    if (!stored) return getDefaultIds()

    const ids: number[] = JSON.parse(stored)

    // One-time injection: add New Examination button when exam module is first enabled
    if (
      settingsStore.getValue('examinations_module') === 'true' &&
      !localStorage.getItem(examInjectedKey)
    ) {
      localStorage.setItem(examInjectedKey, 'true')
      if (!ids.includes(3)) {
        const tasksIdx = ids.indexOf(24)
        const next = tasksIdx !== -1
          ? [...ids.slice(0, tasksIdx), 3, ...ids.slice(tasksIdx + 1)]
          : [...ids, 3]
        localStorage.setItem(storageKey, JSON.stringify(next))
        return next
      }
    }

    return ids
  }

  const savedIds = ref<number[]>(loadInitialIds())

  const activeButtonDefs = computed(() =>
    savedIds.value
      .map(id => BUTTON_MAP.get(id))
      .filter((b): b is HomeScreenButtonDef => b !== undefined)
  )

  function addButton(id: number) {
    if (!savedIds.value.includes(id)) {
      savedIds.value = [...savedIds.value, id]
    }
  }

  function removeButton(id: number) {
    savedIds.value = savedIds.value.filter(i => i !== id)
  }

  function reorder(newIds: number[]) {
    savedIds.value = newIds
  }

  function resetToDefault() {
    savedIds.value = getDefaultIds()
    save()
  }

  function save() {
    localStorage.setItem(storageKey, JSON.stringify(savedIds.value))
  }

  function isActive(id: number) {
    return savedIds.value.includes(id)
  }

  function visibleCatalogButtons(canFn: (action: string, resource: string) => boolean) {
    const settingsStore = useSettingsStore()
    return ALL_BUTTONS.filter(btn => {
      if (!buttonFlagsEnabled(btn, key => settingsStore.getValue(key))) return false
      return canFn(btn.permissionAction, btn.permissionResource)
    })
  }

  return {
    savedIds,
    activeButtonDefs,
    addButton,
    removeButton,
    reorder,
    resetToDefault,
    save,
    isActive,
    visibleCatalogButtons
  }
}
